// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".titleDiv[data-v-d7323a3e]{height:38px;background-color:#f7f7fc;position:relative;padding:0 70px 0 16px;display:flex;line-height:38px;font-weight:450;font-size:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
